import { Badge } from "./ui/badge";

const ago = (iso) => { const d = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000); return d <= 0 ? "today" : d === 1 ? "1 day ago" : `${d} days ago`; };

const OUTCOME = {
  paid: { label: (o) => `Paid ${o.days === 0 ? "same day" : `${o.days}d later`}`, cls: "bg-emerald-100 text-emerald-700" },
  converted: { label: (o) => (o.days != null ? `Picked a plan ${o.days === 0 ? "same day" : `${o.days}d later`}` : "Subscribed"), cls: "bg-emerald-100 text-emerald-700" },
  extended: { label: (o) => `Trial extended${o.days ? ` ${o.days}d` : ""} · no plan yet`, cls: "bg-sky-100 text-sky-700" },
  pending: { label: (o, kind) => (kind === "chased" ? "No payment yet" : "No reply yet"), cls: "bg-amber-100 text-amber-700" },
  locked: { label: () => "Still unpaid · read-only", cls: "bg-red-100 text-red-700" },
  cleared: { label: () => "Cleared (no payment recorded)", cls: "bg-muted text-muted-foreground" },
};

export default function RecoveryOutcomesList({ items }) {
  if (!items?.length) return null;
  return (
    <div className="border-t border-border" data-testid="recovery-outcomes">
      <div className="px-4 py-2 flex items-center justify-between">
        <p className="text-[10px] font-semibold text-muted-foreground">RECENT OUTREACH &amp; WHAT HAPPENED NEXT</p>
        <span className="text-[10px] text-muted-foreground">{items.filter((i) => ["paid", "converted"].includes(i.outcome?.status)).length}/{items.length} led to money</span>
      </div>
      <div className="divide-y divide-border/60">
        {items.map((i) => {
          const o = OUTCOME[i.outcome?.status] || OUTCOME.pending;
          return (
            <div key={i.id || `${i.tenant_id}-${i.at}`} className="px-4 py-1.5 grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr_1.4fr] gap-2 items-center text-[11px]" data-testid={`recovery-outcome-${i.slug || i.tenant_id}-${i.kind}`}>
              <div className="truncate">
                <span className="font-semibold">{i.company_name}</span>
                {i.simulated && <Badge variant="outline" className="ml-1.5 text-[8px] border-violet-400 text-violet-700">SIM</Badge>}
              </div>
              <div className="text-muted-foreground">
                {i.kind === "chased" ? "Chase" : "Win-back"} · {ago(i.at)}{i.by === "auto-chase" ? " · auto" : i.by ? ` · ${i.by.split("@")[0]}` : ""}
              </div>
              <div className="text-muted-foreground">
                {i.kind === "chased" ? (i.amount != null ? `£${Number(i.amount).toFixed(2)} outstanding` : "") : [i.extended_days ? `+${i.extended_days}d trial` : null, i.offer_code ? `code ${i.offer_code}` : null].filter(Boolean).join(" · ")}
              </div>
              <div><Badge className={`text-[9px] ${o.cls}`} data-testid="recovery-outcome-status">{o.label(i.outcome || {}, i.kind)}</Badge></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
